import { render } from "./WCProhibitAlternativeMsg.vue?vue&type=template&id=21dbce30&scoped=true"
import script from "./WCProhibitAlternativeMsg.vue?vue&type=script&lang=js"
export * from "./WCProhibitAlternativeMsg.vue?vue&type=script&lang=js"

import "./WCProhibitAlternativeMsg.vue?vue&type=style&index=0&id=21dbce30&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21dbce30"]])

export default __exports__